export default "__VITE_ASSET__BXZRzXZs__"